import { __decorate } from "tslib";
import { memoized } from "@buildwithflux/shared";
import { chain } from "lodash";
export class RecordCollection {
    records;
    constructor(records) {
        this.records = records;
    }
    get length() {
        return this.records?.size ?? 0;
    }
    isLoaded() {
        return this.records !== null;
    }
    get(id) {
        return this.records?.get(id) ?? null;
    }
    all() {
        return [...(this.records?.values() ?? [])];
    }
    all_() {
        return chain(this.all());
    }
}
export class SKUCollection extends RecordCollection {
    get priceBreakQuantities() {
        return this.all_()
            .flatMap((record) => record.priceBreaks.map((priceBreak) => priceBreak.quantity))
            .uniq()
            .sortBy()
            .value();
    }
    all() {
        return super.all().sort((a, b) => {
            if (a.availableQuantity !== b.availableQuantity) {
                return b.availableQuantity - a.availableQuantity;
            }
            else if (a.unitPrice !== b.unitPrice) {
                return b.unitPrice - a.unitPrice;
            }
            else {
                return a.dpn.localeCompare(b.dpn);
            }
        });
    }
    byDistributor() {
        return this.byDistributor_().value();
    }
    byDistributor_() {
        return this.all_().groupBy((record) => record.distributor);
    }
}
__decorate([
    memoized
], SKUCollection.prototype, "priceBreakQuantities", null);
//# sourceMappingURL=collection.js.map